module.exports = __webpack_public_path__ + "assets/images/right.svg?ver=647c5952";